import React, { useState, useEffect } from "react";
import { Phone, Menu, X, Megaphone } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "CDHCI", href: "#cdhci" },
  { label: "Our Process", href: "#process" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100"
          : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <a
        href="#cdhci"
        data-testid="announcement-bar"
        className="block bg-[#EA580C] text-white text-center text-xs sm:text-sm font-medium py-2.5 px-4 hover:bg-[#C2410C] transition-colors"
      >
        <span className="inline-flex items-center gap-2">
          <Megaphone size={14} className="hidden sm:inline" />
          <span className="uppercase tracking-wider text-[10px] sm:text-xs font-bold bg-white/15 px-2 py-0.5 rounded">
            New
          </span>
          <span>
            We now accept clients funded through Alberta's <strong>Client-Directed Home Care (CDHCI)</strong> program — no out-of-pocket cost for approved hours.
          </span>
          <span className="underline underline-offset-2 font-semibold hidden sm:inline">
            Learn more →
          </span>
        </span>
      </a>
      <nav className="container-x flex items-center justify-between h-20">
        <a
          href="#home"
          data-testid="nav-logo"
          className="flex items-center gap-2"
        >
          <div className="w-10 h-10 rounded-lg aegis-navy-bg flex items-center justify-center text-white font-display font-bold">
            A
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display font-semibold text-lg aegis-navy-text">
              Aegis Care
            </span>
            <span className="text-[10px] uppercase tracking-widest text-gray-500">
              Operations LTD
            </span>
          </div>
        </a>

        <ul className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm font-medium text-gray-700 hover:text-[#3D7A73] transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+17809946439"
            data-testid="nav-phone-cta"
            className="flex items-center gap-2 text-sm font-medium aegis-navy-text hover:text-[#3D7A73]"
          >
            <Phone size={16} />
            <span>780-994-6439</span>
          </a>
          <a
            href="#booking"
            data-testid="nav-book-cta"
            className="btn-primary text-sm"
          >
            Book Consultation
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#0F2537]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-5 space-y-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="block text-base font-medium text-gray-800"
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:+17809946439"
            className="block text-sm font-medium aegis-navy-text"
            data-testid="mobile-nav-phone"
          >
            Call 24/7: 780-994-6439
          </a>
          <a
            href="#booking"
            onClick={() => setOpen(false)}
            className="btn-primary w-full justify-center text-sm"
            data-testid="mobile-nav-book"
          >
            Book Consultation
          </a>
        </div>
      )}
    </header>
  );
};
